export const CATEGORY_FORM_WIDTH = 370;
